<template>
  <multi-selection-tool-button
    icon="refresh"
    :icon-size="15"
    :disabled="disabled"
    :tooltip="$t('Refresh')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableRefreshTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/Refresh.vue